import { tabcordionComp } from '../modules/comp-tabcordion';

const whowehelpSingle = (data, gsap, mm, ScrollTrigger, smoother) => {
    
  const $data = $(data.next.container);
  const $main = $data.find('main');
  
  gsap.to($main, {
    duration: 0.6,
    opacity: 1
  });
    
  const $orb = $data.find('.gradient-orb svg');
  const $hero = $data.find('.hero-container');
  const $transitionBlock = $data.find('.shift-color');
  const $transitionBg = $transitionBlock.find('.bg');
  const $form = $data.find('.cta-form');
  
  if ($orb.length) {
    const orbTl = gsap.timeline({repeat: -1, yoyo: true});
    orbTl.to($orb, {duration: 2.2, ease: 'none', scale: 1.35});
  }
  
  tabcordionComp(data, ScrollTrigger, smoother, gsap);
      
  mm.add("(min-width: 62rem)", () => {
    
    if ($transitionBlock.length) {

      ScrollTrigger.create({
        trigger: $hero,
        start: "-98px -98px", 
        //end: "200% bottom",
        toggleClass: {className: 'blackout', targets: '.single-whowehelp'},
        pin: $hero,
        pinSpacing: false,
      });

      let sdbg = gsap.timeline({
        scrollTrigger: {
          trigger: $transitionBlock,
          start: "top 98px",
          end: "200px 100px",
          scrub: true,
          pin: false,
          markers: false,
        },
      });

      //sdbg.to($transitionBg, {width: '110%', height: '105%'});
      sdbg.to($transitionBg, {scaleX: 1.1, scaleY: 1.05});

    }
    
    smoother.effects($form, {speed: 1.2});
    
  }, '.single-whowehelp');
  
  mm.add("(max-width: 61rem)", () => {
    ScrollTrigger.create({
      trigger: $hero,
      start: "-98px -98px", 
      toggleClass: {className: 'blackout', targets: '.single-whowehelp'},
    });
  }, '.single-whowehelp');
  
  const $diagonal = $data.find('.diagonal-shape'),
        $angle = $data.find('.angle-shape'),
        $circle = $data.find('.circles-shape');

  if ($diagonal.length >= 1) {

    var $diagonalTop = $data.find('.diagonal-top'),
        $linesTop = $diagonalTop.find('.diagonal-group-top').find('line'),
        $linesBottom = $diagonalTop.find('.diagonal-group-bottom').find('line');

    gsap.set($linesTop, {x: -20, y: -20, autoAlpha: 0});
    gsap.to($linesTop, {duration: 0.2, stagger: -0.03, x: 0, y: 0, autoAlpha: 1});

    gsap.set($linesBottom, {x: -20, y: -20, autoAlpha: 0});
    gsap.to($linesBottom, {delay: 0.2, duration: 0.2, stagger: -0.03, x: 0, y: 0, autoAlpha: 1});



  } else if ($angle.length >= 1) {

    var $angleTop = $data.find('.angle-top'),
        $linesTop = $angleTop.find('.angle-group-top').find('path'),
        $linesBottom = $angleTop.find('.angle-group-bottom').find('path');

    gsap.set($angleTop, {autoAlpha: 0});
    gsap.to($angleTop, {duration: 1.5, autoAlpha: 1});

    gsap.set($linesTop, {drawSVG: 0, autoAlpha: 0});
    gsap.to($linesTop, {duration: 0.6, stagger: -0.01, drawSVG: "100%", autoAlpha: 1});

    gsap.set($linesBottom, {drawSVG: 0, autoAlpha: 0});
    gsap.to($linesBottom, {duration: 0.6, stagger: -0.01, drawSVG: "100%", autoAlpha: 1});

  } else if ($circle.length >= 1) {

    var $circlesTop = $data.find('.circles-top'),
        $linesTop = $circlesTop.find('.circles-group-top').find('circle'),
        $linesBottom = $circlesTop.find('.circles-group-bottom').find('circle');

    gsap.set($linesTop, {autoAlpha: 0});
    gsap.to($linesTop, {duration: 0.6, stagger: -0.01, autoAlpha: 1});

    gsap.set($linesBottom, {delay: 0.1, autoAlpha: 0});
    gsap.to($linesBottom, {delay: 0.3, duration: 0.6, stagger: -0.01, autoAlpha: 1});

  }
  
}

export {
  whowehelpSingle
};
